<ng-container *ngIf="(type | async) === 'PP' || (type | async) === 'TOS'; else loading">
    <div class="container">
        <div class="text" *ngIf="(type | async) === 'PP' else termsText">
            <ng-container *ngTemplateOutlet="privacyText"></ng-container>
        </div>
        <div class="confirm-box">
            <span (click)="checkbox()">
                <ion-icon name="checkmark-circle" color="light" *ngIf="(checkboxValue | async) else emptyCheckbox"></ion-icon>
                I HAVE READ, UNDERSTAND, & AGREE WITH THE TERMS.
            </span>
            <div class="buttons">
                <div class="cancel" (click)="cancel()">CANCEL</div>
                <div class="confirm" [ngClass]="{'confirm-disabled':!(checkboxValue | async)}" (click)="confirm()">CONFIRM</div>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #emptyCheckbox><ion-icon name="checkmark-circle" color="medium"></ion-icon></ng-template>

<ng-template #privacyText> 
    <p class="title">
        PRIVACY POLICY
    </p>
    <p>
        Privacy Policy
        <br>Last updated: Feb 1st, 2022
        <br>

        <br>Odysseus Software Company ("us", "we", or "our") operates the Social Poker (“SoPo”) mobile application (the "Service").
        <br>This page informs you of our policies regarding the collection, use and disclosure of Personal Information when you use our Service.
        <br>

        <br>We will not use or share your information with anyone except as described in this Privacy Policy.
        <br>

        <br>We use your Personal Information for providing and improving the Service. By using the Service, you agree to the collection and use of information in accordance with this 
        policy. Unless otherwise defined in this Privacy Policy, terms used in this Privacy Policy have the same meanings as in our Terms and Conditions.
        <br>

        <br>Information Collection and Use
        <br>While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable 
        information may include, but is not limited to, your email address, name, phone number, postal address, other information ("Personal Information").
        <br>

        <br>Log Data
        <br>When you access the Service by or through a mobile device, we may collect certain information automatically, including, but not limited to, the type of mobile device you 
        use, your mobile device unique ID, the IP address of your mobile device, your mobile operating system, the type of mobile Internet browser you use, and other statistics ("Log 
        Data").
        <br>

        <br>In addition, we may use third party services such as Google Analytics that collect, monitor, and analyze this type of information in order to increase our Service's 
        functionality. These third-party service providers have their own privacy policies addressing how they use such information.
        <br>
        
        <br>Location Information
        <br>We may use and store information about your location, if you give us permission to do so. We use this information to provide features of our Service, to improve, and to 
        customize our Service. You can enable or disable location services when you use our Service at anytime, through your mobile device settings.
        <br>
        <br>

        <br>Information Collected
        <br>Odysseus Software Company’s primary objective in collecting user information is to provide and enhance the Service and to enable users to enjoy the Service. When you 
        install, play Odysseus Software Company’s mobile application SoPo or access any of our Services, Odysseus Software Company may automatically receive, collect, and record 
        certain information about you, whether through the Services directly or through a third-party social network (like Facebook) or other third-party services ("Account 
        Information").
        <br>

        <br>Personal Information
        <br>“Personal information” means information about you that can be used to contact or identify you. The personal information types collected in accordance with the Service may 
        vary depending on the activity and may include:
        <br>&emsp;1. Your first and last name (or the name you have associated with your device);
        <br>&emsp;2. Your social network or third-party service user identification number (like your Facebook ID number), which is linked to publicly-available information like your name 
        and profile photo (including the social network ID numbers and other public data of your friends);
        <br>&emsp;3. Your mobile device’s unique identifier (UDID); 
        <br>&emsp;4. Your telephone number;
        <br>&emsp;5. Transaction identifiers for purchases;
        <br>&emsp;6. Your email address used to login the social network;
        <br>&emsp;7. Your profile picture or its URL; or
        <br>&emsp;8. Any other relevant information included in your application, social network or other online profile.
        <br>

        <br>Additionally Odysseus Software Company may acquire information from you through:
        <br>&emsp;1. Your access and participation in message boards;
        <br>&emsp;2. The contents of your requests to our customer support; or
        <br>&emsp;3. Your purchase of virtual items of any type.
        <br>

        <br>If you purchase a license to use in-game virtual currency or virtual items in any of our games, our third-party payment processor will collect the billing and financial 
        information it needs to process your charges. This may include your postal address, e-mail address, and financial information. Odysseus Software Company does not collect or 
        store your financial information, like credit card numbers. However, Odysseus Software Company’s payment processors may share non-financial information with us related to your 
        purchases, like your name, billing address, and the items purchased in order to fulfill your order.
        <br>

        <br>Odysseus Software Company may also obtain the billing and payment information that you provide when your purchase is processed by another party (like Facebook, Apple, or 
        Google) such as when you purchase something in a game you play on a social network or that you downloaded on your mobile device however does not store it.
        <br>

        <br>Our Terms of Service explain our policies and terms relevant to our charges, billing practices, third party credits, and virtual currencies. Please note that such purchases 
        may also be subject to additional policies of such third-party site.
        <br>

        <br>Non-Personal Information
        <br>“Non-personal information” is information that, when taken alone, cannot be used to identify or contact you. Odysseus Software Company may collect non-personal information 
        about your use of its Service in the course of your game play. Odysseus Software Company may also invite you to share non-personal information about yourself which may include 
        but is not limited to:
        <br>&emsp;1. Your age and date of birth;
        <br>&emsp;2. Your gender;
        <br>&emsp;3. Information about the hardware you may own;
        <br>&emsp;4. Your country; 
        <br>&emsp;5. If applicable, your physical geolocation and that of the devices you use to access our Services; 
        <br>&emsp;6. Your favorite websites, friend information, and fan pages; or
        <br>&emsp;7. Any other information included in your application, social network or other online profile.
        <br>

        <br>If non-personal information is collected for an activity that also requires personal information, Odysseus Software Company may combine your non-personal information with 
        your personal information in an attempt to provide you with a better user experience, to improve the value and quality of the Services, to analyze how its Services are used, 
        and to create new features, promotions and functionalities. The Service can also record game play information such as your game session duration or your hands’ history.
        <br>

        <br>In addition to information collected as described above, you may choose to share additional information about yourself throughout the Service, such as on club chat and 
        in-game chat rooms. Any actions you perform with other players are considered public and are in your sole discretion.
        <br>

        <br>Other information Odysseus Software Company may collect includes your occupation, language, zip code, area code, location, and the time zone where a Service is used, as 
        well as information about your computer, mobile device, software, platform, incident data, Internet Protocol (IP) address, network Media Access Control (MAC) address and 
        connection, browser type, browser language, referring pages, exit pages and URLs, number of clicks, domain names, landing pages, pages viewed and the order of those pages, 
        statistics about your interactions with the Service, the amount of time spent on particular pages, and the date and time of this activity, so that Odysseus Software Company can 
        better understand customer behavior and improve its products, Services, and advertising. Odysseus Software Company may also receive either non-personal or public information 
        from third parties in connection with market and demographic studies and/or data that Odysseus Software Company may use to supplement personal information provided directly by 
        you.
        <br>

        <br>Use of Your Information
        <br>

        <br>Cookies
        <br>Cookies are files with small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your computer's 
        hard drive.
        <br>

        <br>We use "cookies" to collect information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept 
        cookies, you may not be able to use some portions of our Service.
        <br>

        <br>Behavioral Remarketing
        <br>Odysseus Software Company may use remarketing/retargeting services provided by Facebook, Google, Snapchat, Twitter, etc., to advertise on third party platforms to you on 
        basis of information collected upon your access to our Service. We, and our third-party vendors, use cookies and/or advertising identifiers to inform, optimize and serve ads 
        based on your past access to our Service. Depending on the privacy settings on your device, the information collection may initiate immediately when you open our application.
        <br>

        <br>Our use of remarking/retargeting services will always be in compliance with the privacy settings on your device, and the applicable platform rules. You may opt out of 
        targeted ads by disabling advertising and tracking cookies in your browser, or by refusing tracking in your device’s privacy settings. You may consult official support 
        information pages (usually entitled “Privacy” or “Advertising”) to learn how to refuse tracking on a particular browser/device. The following links may also contain useful 
        information.
        <br>&emsp;• <a (click)="openAppBrowser('https://support.apple.com/en-us/HT205223')">For iOS devices</a>.
        <br>&emsp;• <a (click)="openAppBrowser('https://support.google.com/googleplay/android-developer/answer/6048248?hl=en#zippy=%2Chow-to-opt-out-of-personalized-ads')">For Android devices</a>.
        <br>&emsp;• <a (click)="openAppBrowser('https://policies.google.com/privacy?hl=en')">For Google</a>.
        <br>&emsp;• <a (click)="openAppBrowser('https://www.facebook.com/help/568137493302217')">For Facebook</a>.
        <br>&emsp;• <a (click)="openAppBrowser('https://help.twitter.com/en/safety-and-security/privacy-controls-for-tailored-ads')">For Twitter</a>.
        <br>
        <br>

        <br>How Odysseus Software Company Uses Your Information
        <br>Odysseus Software Company uses your information to create your SoPo accounts and allows you to play our game, to operate, and optimize our Services, to provide you with a 
        safe, smooth, efficient, and customized experience, to fulfill your specific requests and purchase orders, and to send you other account-related information. In addition, the 
        personal information you provide will allow Odysseus Software Company to send you messages regarding, among other things, in-games (in-app) updates, new products, features, 
        enhancements, special and promotional offers, upgrade opportunities, contests and events of interest. We will keep you informed of your in-game (in-app) activity, including 
        comments from friends, notifications about in-game (in-app) status as well as notifications of gifts. You may also later opt out of certain of these communications, as further 
        detailed below.
        <br>

        <br>Odysseus Software Company may also use personal and non-personal information, both individually and combined together, to better understand the behavior and preferences of 
        its customers, to identify, suggest and enable communication and connections with other Odysseus Software Company users and personalize our Services to you, to provide 
        technical support and respond to inquiries, to troubleshoot technical problems, to help create a safer and more trusted environment for our players by preventing fraud or 
        potentially illegal activities, to deliver and enforcing our Terms of Service, target and serve static and dynamic advertising, to enforce our Terms of Service, to provide an 
        in-game (in-app) leaderboard and promote in-game (in-app) player game records and hand history, to solicit input and feedback to improve Odysseus Software Company products and 
        Services and their content, to ensure proper functioning of our products and Services, to manage and deliver contextual and behavioral advertising, to administer rewards, 
        surveys, contests, or other promotional activities or events sponsored or managed by us or our business partners, to comply with our legal obligations, resolve any disputes we 
        may have with you or other players, and to enforce our agreements with third parties and conduct research.
        <br>

        <br>In all cases of data access and collection, the information you provide will not be disclosed, rented, loaned, leased, sold, or otherwise voluntarily distributed to 
        unaffiliated third parties and will be used solely for the purpose stated herein. Odysseus Software Company will retain your information for as long as your account is active 
        or as needed to provide you Services depends on why we collected this information and how we use it. We will not retain your personal information for longer than is necessary 
        for our business purposes or for legal requirements. For instance, we may retain some information for a few years after you have closed your account if this is necessary to 
        meet our legal obligations or to exercise, defend or establish legal rights. If you wish to cancel your account or request that Odysseus Software Company no longer use your 
        information contact Odysseus Software Company at the email address provided in the Your Rights section below. Note that there may be instances where Odysseus Software Company 
        is legally required to retain your information.
        <br>
        <br>
        <br>

        <br>Communications
        <br>Where you have consented, we may use your Personal Information to contact you with newsletters, marketing or promotional materials and other information that may be of 
        interest to you. You may opt out of receiving any, or all, of these communications from us by following the unsubscribe link or instructions provided in any email we send.
        <br>

        <br>Compliance With Laws
        <br>We will disclose your Personal Information where required to do so by law or subpoena or if we believe that such action is necessary to comply with the law and the 
        reasonable requests of law enforcement or to protect the security or integrity of our Service.
        <br>

        <br>Business Transaction
        <br>If Odysseus Software Company is involved in a merger, acquisition or asset sale, your Personal Information may be transferred. We will provide notice before your Personal 
        Information is transferred and becomes subject to a different Privacy Policy.
        <br>

        <br>Security
        <br>The security of your Personal Information is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. 
        While we strive to use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security.
        <br>
        <br>

        <br>Links To Other Sites
        <br>Our Service may contain links to other sites that are not operated by us. If you click on a third-party link, you will be directed to that third party's site. We strongly 
        advise you to review the Privacy Policy of every site you visit.
        <br>We have no control over, and assume no responsibility for the content, privacy policies or practices of any third-party sites or services.
        <br>

        <br>Children's Privacy
        <br>Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from children under 13. If you are a parent or 
        guardian and you are aware that your child has provided us with Personal Information, please contact us. If we become aware that we have collected Personal Information from a 
        child under age 13 without verification of parental consent, we take steps to remove that information from our servers.
        <br>

        <br>Changes To This Privacy Policy
        <br>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
        <br>

        <br>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
        <br>

        <br>Your Rights
        <br>Our postal address is 1011 w. Cleveland St. Tampa, FL 33609 United States, and our email contact is support&#64;playsopo.com. 
        <br>

        <br>You have the right to access personal information that we process about you.
        <br>You can request information about:
        <br>&emsp;• What personal data we hold about you;
        <br>&emsp;• The purposes of the processing;
        <br>&emsp;• The categories of personal data concerned;
        <br>&emsp;• The recipients to whom the personal data has/will be disclosed;
        <br>&emsp;• How long we intend to store your personal data for;
        <br>&emsp;• If we did not collect the data directly from you, information about the source.
        <br>

        <br>You may also request that we update any incomplete or inaccurate data about you. We will strive to correct this as quickly as possible unless there are valid reasons for 
        not doing so.
        <br>

        <br>You also have the right to request that we delete your personal data in accordance with GDPR.
        <br>

        <br>You may request we action your rights by contacting us at Odysseus Software Company. You can make your request by emailing us at support&#64;playsopo.com. 
        <br>If we receive a request from you to exercise any of the above rights, we will ask you to verify your identity before acting on the request; this is to ensure that your data 
        is protected and kept secure.
        <br>
    </p>
</ng-template>

<ng-template #termsText> 
    <p class="title">
    TERMS OF SERVICE
    </p>
    <p> 
        Terms of Use ("Terms")
        <br>Last updated: Feb 1st, 2022
        <br>
        <br>Please read these Terms of Use ("Terms", "Terms of Use") carefully before using the Social Poker (“SoPo”) mobile application. Odysseus Software Company, ("us", "we", or "our") operates the 
        SoPo mobile application, website, social media pages and related services (collectively, the "Service").
        <br>

        <br>Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms. These Terms apply to all visitors, users, and others who access or use the Service. 
        If you disagree with any part of the terms, then you may not access the Service.
        <br>

        <br>This software is for entertainment only. Using this software to gamble for money or anything of value is done so at your own risk. By registering for an Account or otherwise using the Service, 
        you affirm that you (1) are 18 years or older, or 13 years or older and have your parent or guardian's consent to the Agreements, and (2) have the power to enter a binding contract with us and not 
        be barred from doing so under any applicable laws. 
        <br>

        <br>Purchases
        <br>If you wish to purchase any product or service made available through the Service ("Purchase"), you may be asked to supply certain information relevant to your Purchase including, without 
        limitation, your credit card number, the expiration date of your credit card, your billing address, and your shipping information.
        <br>

        <br>You represent and warrant that: (i) you have the legal right to use any credit card(s) or other payment method(s) in connection with any Purchase; and that (ii) the information you supply to 
        us is true, correct, and complete.
        <br>By submitting such information, you grant us the right to provide the information to third parties for purposes of facilitating the completion of Purchases.
        <br>

        <br>We reserve the right to refuse or cancel your order at any time for certain reasons including but not limited to: product or service availability, errors in the description or price of the 
        product or service, error in your order, or other reasons.
        <br>

        <br>We reserve the right to refuse or cancel your order if fraud or an unauthorized or illegal transaction is suspected.
        <br>

        <br>
        <br>

        <br>Availability, Errors, and Inaccuracies
        <br>We are constantly updating our offerings of products and services on the Service. The products or services available on our Service may be mispriced, described inaccurately, or unavailable, 
        and we may experience delays in updating information on the Service and in our advertising on other websites.
        <br>We cannot and do not guarantee the accuracy or completeness of any information, including prices, product images, specifications, availability, and services. We reserve the right to change or 
        update information and to correct errors, inaccuracies, or omissions at any time without prior notice.
        <br>

        <br>Contests and Promotions
        <br>Any contests or other promotions (collectively, "Promotions") made available through the Service may be governed by rules that are separate from these Terms. If you participate in any 
        Promotions, please review the applicable rules as well as our Privacy Policy. If the rules for a Promotion conflict with these Terms, the Promotion rules will apply.
        <br>

        <br>Price Changes
        <br>Odysseus Software Company, in its sole discretion and at any time, may modify the purchase price for the in-store items. Any in-store item price changes will become effective at the end of the 
        then-current purchase.
        <br>

        <br>Refunds
        <br>As with most downloadable software products, items bought in our games (in-app purchases) are non-refundable. In rare cases, exceptions can be applied.
        <br>

        <br>If the purchase was made on an Apple (iOS) device:
        <br>For purchases made on an iOS device, Odysseus Software Company is not able to handle refunds directly. Please visit Apple support and select the "Contact iTunes store support" link, then 
        "Purchases, billing and redemption" and choose the option that fits you best.
        <br>
        <br>If the purchase was made on a Google (Android) device:
        <br>For purchases made on a Google device Odysseus Software Company is not able to handle refunds directly. Please visit Google Play Help and select “Get a refund on Google Play” underneath 
        “Refunds &amp; returns” drop-down and choose the option that fits you best. It may help to have your transaction ID ready. Receipts for transactions have been emailed to you by Google after each 
        purchase.
        <br>

        <br>Content
        <br>Our Service allows you to post, link, store, share and otherwise make available certain information, text, graphics, videos, or other material ("Content"). You are responsible for the Content 
        that you post to the Service, including its legality, reliability, and appropriateness.
        <br>

        <br>By posting Content to the Service, you grant us the right and license to use, modify, publicly perform, publicly display, reproduce, and distribute such Content on and through the Service. You 
        retain any and all of your rights to any Content you submit, post or display on or through the Service and you are responsible for protecting those rights. You agree that this license includes the 
        right for us to make your Content available to other users of the Service, who may also use your Content subject to these Terms.
        <br>
        
        <br>You represent and warrant that: (i) the Content is yours or you have the right to use it and grant us the rights and license as provided in these Terms, and (ii) the posting of your Content on 
        or through the Service does not violate the privacy rights, publicity rights, copyrights, contract rights or any other rights of any person.
        <br>

        <br>Accounts
        <br>When you create an account with us, you must provide us information that is accurate, complete, and current at all times. Failure to do so constitutes a breach of the Terms, which may result 
        in immediate termination of your account on our Service.
        <br>

        <br>You are responsible for safeguarding the password that you use to access the Service and for any activities or actions under your password, whether your password is with our Service or a 
        third-party service.
        <br>

        <br>You agree not to disclose your password to any third party. You must notify us immediately upon becoming aware of any breach of security or unauthorized use of your account.
        <br>

        <br>You may not use as a username the name of another person or entity or that is not lawfully available for use, a name or trademark that is subject to any rights of another person or entity 
        other than you without appropriate authorization, or a name that is otherwise offensive, vulgar, or obscene.
        <br>

        <br>Copyright Policy
        <br>We respect the intellectual property rights of others. It is our policy to respond to any claim that Content posted on the Service infringes the copyright or other intellectual property 
        infringement ("Infringement") of any person.
        <br>If you are a copyright owner, or authorized on behalf of one, and you believe that the copyrighted work has been copied in a way that constitutes copyright infringement that is taking place 
        through the Service, you must submit your notice in writing to the attention of "Copyright Infringement" at support&#64;playsopo.com and include in your notice a detailed description of the alleged 
        Infringement.
        <br>

        <br>You may be held accountable for damages (including costs and attorneys' fees) for misrepresenting that any Content is infringing your copyright.
        <br>

        <br>Intellectual Property
        <br>The Service and its original content (excluding Content provided by users), features and functionality are and will remain the exclusive property of Odysseus Software Company and its 
        licensors. The Service is protected by copyright, trademark, and other laws of both the United States and foreign countries. Our trademarks may not be used in connection with any product or 
        service without the prior written consent of Odysseus Software Company.
        <br>

        <br>Links To Other Websites
        <br>Our Service may contain links to third-party websites or services that are not owned or controlled by Odysseus Software Company.
        <br>

        <br>Odysseus Software Company has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third-party websites or services. You further acknowledge 
        and agree that Odysseus Software Company shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or 
        reliance on any such content, goods or services available on or through any such websites or services.
        <br>

        <br>We strongly advise you to read the terms and conditions and privacy policies of any third-party websites or services that you visit.
        <br>

        <br>Termination
        <br>We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
        <br>

        <br>Upon termination, your right to use the Service will immediately cease. If you wish to terminate your account, you may simply discontinue using the Service.
        <br>

        <br>Limitation Of Liability
        <br>In no event shall Odysseus Software Company nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive 
        damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from (i) your access to or use of or inability to access or use the Service; (ii) 
        any conduct or content of any third party on the Service; (iii) any content obtained from the Service; and (iv) unauthorized access, use or alteration of your transmissions or content, whether 
        based on warranty, contract, tort (including negligence) or any other legal theory, whether or not we have been informed of the possibility of such damage, and even if a remedy set forth herein is 
        found to have failed of its essential purpose.
        <br>

        <br>Disclaimer
        <br>Your use of the Service is at your sole risk. The Service is provided on an "AS IS" and "AS AVAILABLE" basis. The Service is provided without warranties of any kind, whether express or 
        implied, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, non-infringement or course of performance.
        <br>

        <br>Odysseus Software Company, its subsidiaries, affiliates, and its licensors do not warrant that (a) the Service will function uninterrupted, secure or available at any particular time or 
        location; (b) any errors or defects will be corrected; (c) the Service is free of viruses or other harmful components; or (d) the results of using the Service will meet your requirements.
        <br>

        <br>Governing Law
        <br>These Terms shall be governed and construed in accordance with the laws of the United States, without regard to its conflict of law provisions.
        <br>

        <br>Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If any provision of these Terms is held to be invalid or unenforceable by a court, 
        the remaining provisions of these Terms will remain in effect. These Terms constitute the entire agreement between us regarding our Service and supersede and replace any prior agreements we might 
        have between us regarding the Service.
        <br>

        <br>Changes
        <br>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material we will try to provide at least 30 day’s notice prior to any new terms 
        taking effect. What constitutes a material change will be determined at our sole discretion.
        <br>

        <br>By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, please stop using the 
        Service.
        <br>

        <br>Contact Us
        <br>If you have any questions about these Terms, please contact us at support&#64;playsopo.com. 
        <br>
    </p>
<br/></ng-template>

<ng-template #loading>
    <div class="loading-spinner">
        <ion-spinner></ion-spinner>
    </div>
</ng-template>
